/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerievideoVideoidLangsQueryResponse,
  GetApiV1SerievideoVideoidLangsPathParams,
  GetApiV1SerievideoVideoidLangsQueryParams,
  GetApiV1SerievideoVideoidLangs401,
  GetApiV1SerievideoVideoidLangs404,
  GetApiV1SerievideoVideoidLangs500,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangs.ts";

function getGetApiV1SerievideoVideoidLangsUrl(
  videoId: GetApiV1SerievideoVideoidLangsPathParams["videoId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/serievideo/${videoId}/langs` as const,
  };
  return res;
}

/**
 * @description Retorna a lista paginada de traduções (idiomas) de um vídeo. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs}
 */
export async function getApiV1SerievideoVideoidLangs(
  videoId: GetApiV1SerievideoVideoidLangsPathParams["videoId"],
  params?: GetApiV1SerievideoVideoidLangsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerievideoVideoidLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangs401
      | GetApiV1SerievideoVideoidLangs404
      | GetApiV1SerievideoVideoidLangs500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerievideoVideoidLangsUrl(videoId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
